var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.153 18.408C23.42 16.136 24.053 15 25 15C25.947 15 26.58 16.136 27.847 18.408L28.175 18.996C28.535 19.642 28.715 19.965 28.995 20.178C29.275 20.391 29.625 20.47 30.325 20.628L30.961 20.772C33.421 21.329 34.65 21.607 34.943 22.548C35.235 23.488 34.397 24.469 32.72 26.43L32.286 26.937C31.81 27.494 31.571 27.773 31.464 28.117C31.357 28.462 31.393 28.834 31.465 29.577L31.531 30.254C31.784 32.871 31.911 34.179 31.145 34.76C30.379 35.341 29.227 34.811 26.925 33.751L26.328 33.477C25.674 33.175 25.347 33.025 25 33.025C24.653 33.025 24.326 33.175 23.672 33.477L23.076 33.751C20.773 34.811 19.621 35.341 18.856 34.761C18.089 34.179 18.216 32.871 18.469 30.254L18.535 29.578C18.607 28.834 18.643 28.462 18.535 28.118C18.429 27.773 18.19 27.494 17.714 26.938L17.28 26.43C15.603 24.47 14.765 23.489 15.057 22.548C15.349 21.607 16.58 21.328 19.04 20.772L19.676 20.628C20.375 20.47 20.724 20.391 21.005 20.178C21.286 19.965 21.465 19.642 21.825 18.996L22.153 18.408Z",
    stroke: "#B050F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_169_298)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.80678,
    y: 39.2458,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-69.817 -5.80678 39.2458)",
    stroke: "url(#paint0_linear_169_298)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_169_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8305 25.3976C16.1351 23.4245 15.2873 22.4385 15.614 21.5496C15.9408 20.6608 17.2254 20.4586 19.795 20.0533L20.4601 19.9483C21.1906 19.8333 21.5559 19.7758 21.8524 19.5864C22.149 19.3971 22.3439 19.0959 22.7337 18.4934L23.0883 17.9461C24.4598 15.8293 25.1448 14.7717 26.1291 14.8214C27.1121 14.8716 27.7437 15.9966 29.0057 18.2472L29.3319 18.8295C29.6904 19.4684 29.8698 19.789 30.1558 20.0081C30.4427 20.2276 30.8043 20.3222 31.5265 20.5109L32.1847 20.6826C34.7283 21.348 35.9998 21.6801 36.2808 22.5995C36.5619 23.5189 35.6669 24.4173 33.8778 26.2123L33.4146 26.6781C32.9055 27.1877 32.6519 27.4429 32.5322 27.7686C32.4125 28.0943 32.4405 28.453 32.4983 29.171L32.5498 29.8249C32.7502 32.3522 32.8501 33.6164 32.0418 34.1343C31.2309 34.6534 30.0471 34.0829 27.678 32.9425L27.0663 32.6473C26.3929 32.3231 26.0561 32.1609 25.696 32.1436C25.3356 32.1241 24.9913 32.2521 24.3052 32.5071L23.6786 32.7391C21.2604 33.6369 20.0505 34.085 19.268 33.4863C18.4856 32.8875 18.6484 31.6359 18.9753 29.1351L19.0596 28.4885C19.1524 27.7779 19.1987 27.423 19.0957 27.0858C18.9928 26.7486 18.7513 26.4691 18.2692 25.9084L17.8305 25.3976Z",
    stroke: "#B050F9",
    strokeWidth: 1.5
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "url(#paint1_linear_169_298)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_169_298",
    x: -9.09039,
    y: -9.09033,
    width: 68.1807,
    height: 68.1807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_169_298"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_298",
    x1: -7.93309,
    y1: 68.2555,
    x2: 43.94,
    y2: 68.1426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#9235D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471154,
    stopColor: "#D51A90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#9235D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D41A90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_298",
    x1: -0.842697,
    y1: 28.4161,
    x2: 51.0304,
    y2: 28.3032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#9235D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471154,
    stopColor: "#D51A90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#9235D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D41A90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_169_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(9.59662 32.1228) rotate(-69.817)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.689865194ed8e8fe029d2c761c867f3c.svg";
export { ForwardRef as ReactComponent };